import { AlertTriangleIcon } from "lucide-react";

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({
  message = "Failed to load data",
  onRetry,
}: ErrorStateProps) {
  return (
    <div role="alert" className="flex flex-col items-center justify-center py-16 text-block-red">
      <AlertTriangleIcon className="h-10 w-10 mb-3 opacity-70" />
      <p className="text-sm mb-3">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="rounded-md border border-block-red/40 px-3 py-1.5 text-xs text-block-red hover:bg-block-red/10 transition-colors"
        >
          Retry
        </button>
      )}
    </div>
  );
}
